import {
  IAddHeadquarter,
  IHeadquarterListVM,
  IHeadquarterVM,
  IUpdateHeadquarter,
  IUpdateHeadquarterTemplate,
  IUpdateHeadquarterCancelationPolicy,
} from "../../models/response/IHeadquarterResponse";

// Initial State set for All Headquarter List
export const HeadquarterInitialState: IHeadquarterListVM = {
  PagingDetails: {
    TotalRecords: 1,
    TotalPages: 1,
    CurrentPage: 1,
    PageSize: 10,
  },
  HeadquarterList: [],
};

// Initial State set for Headquarter Add Form
export const AddHeadquarterState: IHeadquarterVM = {
  Id: -1,
  HeadquarterName: "",
  BusinessType: {
    Id: -1,
    TypeName: "",
    Description: ""
  },
  BusinessTypeId : -1,
  Email: "",
  Password: "",
  ProductIcon: "",
  TreatmentIcon: "",
};

export const AddUpdateHeadquarterTemplateState: IUpdateHeadquarterTemplate = {
  Id: -1,
  TemplateBeforeOne: "",
  TemplateBeforeTwo: "",
  TemplateAfterOne: "",
  TemplateAfterTwo: "",
};

export const AddUpdateHeadquarterCancelationPolicyState: IUpdateHeadquarterCancelationPolicy = {
  Id: -1,
  HeadquarterCancelationPolicy: "",
  HeadquarterCancelationText: "",
  ShowOnFilter: false,
};
